<h1 mat-dialog-title class="primary">Spenden für 'Dolly'</h1>
<mat-dialog-content>
    <section>
        <p>Dieser Spendenaufruf wendet sich an YSTM-Mitglieder und Freunde des YSTM.
        <p>
        <p>Hintergrund ist, dass unser Rettungsboot 'Dolly' in der Saison 2024 eine kapitalen
            Getriebe-Schaden am Motor hatte.
        <p>
        <p>Eine Reparatur war kurzfristig nicht möglich, so mussten wir - unter Einbezug mehrerer
            Experten-Einschätzungen - kurzfristig einen neuen Motor für die 'Dolly' bestellen.
        <p>
        <p>Ein Motor-Ersatz für die Dolly war im Haushalt 2024 des YSTM in keiner Weise geplant oder erwartet.</p>
        <p>Aus diesem Grund bitten wir um Spenden von Mitgliedern des YSTM und Club-Freunden.</p>
    </section>
    <section>
        <p>Wenn ihr spenden möchtet:</p>
        <ul>
            <li><span class="li-button"><span>Empfänger: Yachtclub Steinhuder Meer e.V.</span><button mat-icon-button
                        (click)="copyToClipboard('Empfänger','Yachtclub Steinhuder Meer e.V.')"><mat-icon>content_copy</mat-icon></button></span>
            </li>
            <li><span class="li-button"><span>IBAN: DE68 255 914 1331 4143 2015</span><button mat-icon-button
                        (click)="copyToClipboard('IBAN','DE68255914133141432015')"><mat-icon>content_copy</mat-icon></button></span>
            </li>
            <li><span class="li-button"><span>Verwendungszweck: Spende Dolly</span><button mat-icon-button
                        (click)="copyToClipboard('Verwendungszweck','Spende Dolly')"><mat-icon>content_copy</mat-icon></button></span>
            </li>
        </ul>
        <p>Vielen Dank! Eine entsprechende Spendenquittung stellt der Kassenwart bereit.</p>
        <p class="mat-caption">PS: Um das Spenden zu erleichtern, verwendet das Icon <mat-icon
                inline>content_copy</mat-icon> um Daten in die Zwischenablage zu übernehmen.</p>
    </section>
    <section>
        <p>Alternativ kann eine Spendenzusage in einer Nachricht an den Kassenwart erstellt werden:</p>
        <a routerLink="/kontakt/kassenwart" target="_blank" mat-stroked-button>Nachricht an den Kassenwart</a>
    </section>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="primary" mat-dialog-close>OK</button>
</mat-dialog-actions>